export default {"src":"/_next/static/media/purple.5eef25de.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};